
import {Component, Prop, Vue} from "vue-property-decorator";
import SimpleDialog from "@/components/SimpleDialog.vue";
import {Getter} from "vuex-class";

@Component({
    components: {
        SimpleDialog,
    },
})

export default class DisableNotificationBySmsAndMail extends Vue {

@Getter private currentUser: any;
private showDialog: boolean = false;
private switchStateInDatabase: boolean = false;
private showDialogAcivateNotif: boolean = false;
private switchState: boolean = false;

private change() {
    if (this.switchState && !this.switchStateInDatabase) {
        this.showDialog = true;
        this.showDialogAcivateNotif = false;
    } else if (!this.switchState && this.switchStateInDatabase) {
        this.showDialogAcivateNotif = true;
    } else {
        this.showDialogAcivateNotif = false;
    }
}
private getNotificationStatus() {
    this.switchStateInDatabase = this.currentUser.blockNotification;
    this.switchState = this.currentUser.blockNotification;
}
private mounted() {
    this.getNotificationStatus();
}
private async confirm(): Promise<void> {
    return await this.$store.dispatch("users/changeNotification", {
            id: this.currentUser.id,
            notification : this.switchState,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                icon: "icon-picto_courrier",
                msg: this.showDialog ? this.$i18n?.t("notification.notifactionDisableAlert")
                : this.$i18n?.t("notification.notifactionActivateAlert"),
            });
        }).catch((err) => {
            this.$store.commit("alerts/displayError", { msg: err });
       })
        .finally(() => {
            this.showDialog = false;
            this.showDialogAcivateNotif = false;
            this.$store.dispatch("oauth/userByCurrentToken")
              .finally(() => {
                this.getNotificationStatus();
            });
        });
}

private cancel() {
    this.showDialogAcivateNotif = false;
    this.switchState = true;
}

}
